import axios from 'axios';
const API_ROOT_LOCAL = import.meta.env.VITE_AXIOS_API_URL_ROOT; //dev
const API_BASE_ROOT = import.meta.env.VITE_AXIOS_BASE_URL_ROOT;
export const axiosDelete = async (url, deleteID, isBase = false) => {
  try {
    const config = {
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    };
    return await axios.delete(
      `${isBase ? API_BASE_ROOT : API_ROOT_LOCAL}/${url}/${deleteID ? deleteID : null}`,
      config,
    );
  } catch (error) {
    console.error('HTTP POST request failed', error['message']);
  }
};
